import { createStore } from "@stencil/store";

interface ConversationState {
  conversationTitle: string;
  conversationId: string;
  isGroup: boolean;
  conversationImageUrl: string;
  opponentDetails?: {
    userName: string;
    userProfileImageUrl: string;
  };
}

const { state, onChange } = createStore<ConversationState>({
  conversationTitle: '',
  conversationId: '',
  isGroup: false,
  conversationImageUrl: '',
  opponentDetails: {
    userName: '',
    userProfileImageUrl: ''
  }
});

export const conversationStore = {
  state,
  
  // Update conversation title
  updateTitle(newTitle: string) {
    state.conversationTitle = newTitle;
  },

  // Update entire conversation details
  updateConversationDetails(details: Partial<ConversationState>) {
    Object.assign(state, details);
  },

  // Subscribe to changes
  onChange: onChange
}; 